export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="rounded-xl md:rounded-2xl overflow-hidden mb-10">
          <div className="relative w-full h-[280px] md:h-[380px]">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20diagonal%20arrangement%20of%20premium%20lifestyle%20products%20including%20a%20leather%20backpack%20watch%20and%20scarf%20draped%20across%20a%20light%20oak%20wooden%20surface%2C%20warm%20afternoon%20sunlight%20streaming%20through%20sheer%20curtains%2C%20soft%20bokeh%20background%2C%20luxurious%20editorial%20still%20life%2C%20muted%20neutral%20color%20palette%20with%20warm%20caramel%20accents%2C%20sophisticated%20catalog%20photography%2C%20no%20text%2C%20no%20visible%20logos%2C%20refined%20atmosphere&width=1400&height=700&seq=cta-collage-fresh-v2&orientation=landscape"
              alt="Curated fashion product collage"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
          </div>
        </div>

        <div className="text-center max-w-[600px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-snug mb-2">
            Skip the guesswork.
          </h2>
          <p className="font-heading text-xl md:text-2xl text-foreground-500 italic mb-8">
            Embrace <span className="not-italic font-semibold text-foreground-900">smart comparison</span> with
          </p>
          <p className="font-heading text-xl md:text-2xl text-foreground-500 italic mb-10">
            our updated hipobuy sheet.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-white font-semibold text-sm rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            buy it now
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}